import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAnalytics, Analytics, setUserId, logEvent } from 'firebase/analytics';
import {
    IAnalyticsParams,
    IAnalyticsRepository,
} from 'repositories/AnalyticsRepository/interfaces';
import { Environment } from 'constants/envConfig';

const getCredentials = () => {
    if (GLOBAL_CONFIG.environment === Environment.production) {
        return {
            apiKey: 'AIzaSyCEuPy_I-tBViP-Mk3N11Zc40nTJiswRt8',
            authDomain: 'twainsport-7d7b6.firebaseapp.com',
            projectId: 'twainsport-7d7b6',
            storageBucket: 'twainsport-7d7b6.appspot.com',
            messagingSenderId: '895143004728',
            appId: '1:895143004728:web:f209b42bbf274d510fb4cd',
            measurementId: 'G-LWQCS9CDQ7',
        };
    }

    return {
        apiKey: 'AIzaSyA2w5Z4S0Gm42ZDu04LeKZflVqsB861Saw',
        authDomain: 'twainsport-internal.firebaseapp.com',
        projectId: 'twainsport-internal',
        storageBucket: 'twainsport-internal.appspot.com',
        messagingSenderId: '747457563053',
        appId: '1:747457563053:web:10ccaed60e029bccd1f924',
        measurementId: 'G-KQJ9HFC1ZT',
    };
};

export default class AnalyticsRepository implements IAnalyticsRepository {
    private firebaseApp: FirebaseApp;

    private analytics: Analytics;

    public init = (params: IAnalyticsParams): void => {
        try {
            this.firebaseApp = initializeApp(getCredentials());

            this.analytics = getAnalytics(this.firebaseApp);

            if (params.userId && params.partnerCode) {
                setUserId(this.analytics, `${params.partnerCode}_${params.userId}`);
            }
        } catch {}
    };

    public trackStandings = (place: string) => {
        logEvent(this.analytics, 'standings', { place });
    };

    public trackBoTabSelection = (tabName: string) => {
        logEvent(this.analytics, 'bo_tab_selection', { tabName });
    };

    public trackSound = (status: string) => {
        logEvent(this.analytics, 'sound', { status });
    };

    public trackOpenHTP = () => {
        logEvent(this.analytics, 'open_htp');
    };

    public trackMultiPlaceBet = (page: string) => {
        logEvent(this.analytics, 'multi_place_bet', { page });
    };

    public trackB2cOpen = (b2cOpenSource: string) => {
        logEvent(this.analytics, 'b2c_open', { b2cOpenSource });
    };

    public trackMatchInfo = (matchInfoSource: string) => {
        logEvent(this.analytics, 'match_info_open', { matchInfoSource });
    };

    public trackProfileOpen = () => {
        logEvent(this.analytics, 'profile_open_game_page');
    };

    public trackMyBetsOpen = (myBetsOpenSource: string) => {
        logEvent(this.analytics, 'my_bets_open', { myBetsOpenSource });
    };

    public trackParticipantsOpen = () => {
        logEvent(this.analytics, 'participants_open');
    };

    public trackBetSlipTypeTabs = (betSlipTypeTabName: string) => {
        logEvent(this.analytics, 'bet_slip_tab', { betSlipTypeTabName });
    };

    public trackBetSlipComponent = (betSlipComponent: string) => {
        logEvent(this.analytics, 'bet_slip_component', { betSlipComponent });
    };

    public trackBetSlipLocation = (betSlipLocation: string) => {
        logEvent(this.analytics, 'bet_slip_location', { betSlipLocation });
    };

    public trackMatchNavigation = (matchNavigation: string) => {
        logEvent(this.analytics, 'match_navigation', { matchNavigation });
    };

    public trackFullscreen = (fullscreenStatus: string) => {
        logEvent(this.analytics, 'fullscreen', { fullscreenStatus });
    };

    public trackReplay = () => {
        logEvent(this.analytics, 'replay');
    };

    public trackParticipantOpen = () => {
        logEvent(this.analytics, 'participant_open');
    };

    public trackParticipantsFilter = (filter: string | number) => {
        logEvent(this.analytics, 'participants_filter', { filter });
    };

    public trackChangeRoute = (pathName: string) => {
        logEvent(this.analytics, 'screen_view', {
            firebase_screen: pathName,
            firebase_screen_class: null,
        });
    };

    public trackGui = (guiStatus: boolean) => {
        logEvent(this.analytics, 'gui', { guiStatus: guiStatus ? 'on' : 'off' });
    };

    public trackStandingsMetaInfo = (standingsMetaInfo: string) => {
        logEvent(this.analytics, 'standings_meta_info', { standingsMetaInfo });
    };
}
